// Translations. English is the fallback for every missing key (zh-TW lacks some), so every user needs it and it
// ships with the app. Traditional Chinese is fetched only when that locale is chosen; svelte-i18n switches the
// locale after the dictionary has arrived, so no untranslated keys are shown in between.
import { addMessages, getLocaleFromNavigator, init, locale, register, waitLocale } from 'svelte-i18n';
import en from './en.json';

addMessages('en', en);
register('zh-TW', () => import('./zh-TW.json'));

/** Starts with the browser's language; resolves once its dictionary is there (English if it cannot be loaded). */
export function startI18n() {
  init({ fallbackLocale: 'en', initialLocale: getLocaleFromNavigator() });
  return waitLocale().catch((error) => {
    console.warn('translations could not be loaded, using English', error);
    return locale.set('en');
  });
}
